import type { LinkDetail } from '@vividseats/vivid-ui-kit'

import type { LinkDetail as WidgetLinkDetail } from '@/components/shared/link-widget'
import type { Performer } from '@/types/app-types'

export function getSortedPerformerLinks(performers: Performer[], performerNameSuffix = ''): LinkDetail[] {
    const performerLinks: LinkDetail[] = []

    // Exclude performers without webPath and organicUrl
    for (const { id, name: performerName, webPath, organicUrl } of performers) {
        const url: string | undefined = webPath || organicUrl
        if (url) {
            performerLinks.push({ id, name: `${performerName}${performerNameSuffix}`, url })
        }
    }

    performerLinks.sort((performer1, performer2) =>
        performer1.name.toLowerCase().localeCompare(performer2.name.toLowerCase()),
    )

    return performerLinks
}

export function getWidgetLinks(links: LinkDetail[]): WidgetLinkDetail[] {
    return links.map((link) => ({ url: link.url || '', label: link.name }))
}
